// generated file, if you want to edit this file manually change the word "generated" to "manual"
import MaterialIcon from "@material-ui/core/Icon";
import React from "react";
import { excludeKeys, makeThemedStyles } from "./../utils";
const useStylesForBottomMenuIcon = makeThemedStyles(
  "BottomMenuIcon",
  (theme) => ({
    BottomMenuIconNew: {
      width: "3.2em",
      height: "3.2em",
      marginBottom: "1em !important",
    },
  })
);
type PropType = React.ComponentProps<typeof MaterialIcon>;
export const BottomMenuIcon: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStylesForBottomMenuIcon();
  const enabledClasses = excludeKeys(styles, [
    "BottomMenuIcon",
    "BottomMenuIconNew",
  ]);
  /* eslint-disable */
  return (
    <MaterialIcon
      {...props}
      classes={{
        root: styles.BottomMenuIconNew,
        ...enabledClasses,
      }}
      className={styles.BottomMenuIconNew}
    >
      {props?.children}
    </MaterialIcon>
  );
};
export default BottomMenuIcon;
